import { NgClass, NgIf } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-icon-and-button-card',
  templateUrl: './icon-and-button-card.component.html',
  styleUrls: ['./icon-and-button-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [NgIf, NgClass],
})
export class IconAndButtonCardComponent {
  @Input() public cardTitle: string;
  @Input() public iconClass: string;
  @Input() public imagePath: string;
  @Input() public htmlContent: string;
}
